import { render, staticRenderFns } from "./CombinedLabel.vue?vue&type=template&id=6dc15c64&scoped=true"
import script from "./CombinedLabel.vue?vue&type=script&lang=js"
export * from "./CombinedLabel.vue?vue&type=script&lang=js"
import style0 from "./CombinedLabel.vue?vue&type=style&index=0&id=6dc15c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc15c64",
  null
  
)

export default component.exports